import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

type HeadingSize = 'display' | 'headline' | 'title' | 'heading' | 'subheading'

interface DisplayHeadingProps {
    children: ReactNode
    as?: 'h1' | 'h2' | 'h3' | 'h4' | 'p'
    size?: HeadingSize
    className?: string
    id?: string
}

const SIZES: Record<HeadingSize, string> = {
    display: 'text-display [font-weight:380]',
    headline: 'text-headline [font-weight:400]',
    title: 'text-title [font-weight:420]',
    heading: 'text-heading [font-weight:450]',
    subheading: 'text-subheading [font-weight:500]'
}

/** Fraunces headings on the shared type scale (tight tracking is built into each size). */
const DisplayHeading: FC<DisplayHeadingProps> = ({ children, as: Tag = 'h2', size = 'title', className, id }): ReactNode => {
    return (
        <Tag id={id} className={cn('font-heading text-foreground', SIZES[size], className)}>
            {children}
        </Tag>
    )
}

export default DisplayHeading
